import { Component, inject, OnInit, signal } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { TranslatePipe } from '@ngx-translate/core';
import { CalendarService } from '../../../dashboard/services/calendar.service';
import { MerchantsService } from '../../../core/services/merchants.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { StoresService } from '../../../core/services/stores.service';
import { TeyaService } from '../../../core/services/teya.service';
import { UserService } from '../../../core/services/user.service';
import { Dialog } from '@angular/cdk/dialog';
import { SimplePaymentModalComponent } from '../simple-payment-modal/simple-payment-modal.component';

@Component({
    selector: 'app-choose-book-or-block-modal',
    templateUrl: './choose-book-or-block-modal.component.html',
    styleUrls: ['./choose-book-or-block-modal.component.scss'],
    imports: [TranslatePipe],
    standalone: true
})
export class ChooseBookOrBlockModalComponent implements OnInit {

  public store;
  public user;
  public provider;

  private readonly bsModalRef = inject(BsModalRef);
  private readonly modalService = inject(BsModalService);
  private readonly calendarService = inject(CalendarService);
  private readonly merchantService = inject(MerchantsService);
  private readonly storesService = inject(StoresService);
  private readonly teyaService = inject(TeyaService);
  private readonly userService = inject(UserService);
  private readonly dialog = inject(Dialog);

  public activeMerchant = toSignal(this.merchantService.activeMerchant);

  public hasLegacyPosIntegration = toSignal(this.storesService.hasLegacyPosIntegration());
  public teyaConnectionStatus = signal<{ active: boolean } | null>(null);

  ngOnInit() {
    const storeId = this.store?.id;
    if (storeId) {
      this.teyaService.checkOrFetchConnectionStatus(storeId).subscribe((status) => {
        this.teyaConnectionStatus.set(status);
      });
    }
  }

  book() {
    this.modalService.setDismissReason('book');
    this.bsModalRef.hide();
  }
  block() {
    this.modalService.setDismissReason('block');
    this.bsModalRef.hide();
  }

  canCreateHoliday() {
    if (this.user?.role === 'provider' && !this.store.allowProvidersToCreateHolidays) {
      return false;
    }

    return true;
  }

  canCreateBooking() {
    if (this.user?.role === 'provider' && this.store?.allowProvidersToCreateBookings === false) {
      return false;
    }

    return true;
  }

  canCreateSale() {
    return this.store?.salesModuleActive && this.userService.userHasPermissions('canCreateEditSales');
  }

  canPayWithTeya() {
    return !this.canCreateSale()
      && !this.hasLegacyPosIntegration()
      && this.teyaConnectionStatus()?.active === true;
  }

  createNewInvoice() {
    this.calendarService.createNewInvoice(this.activeMerchant(), this.store);
  }

  paywithTeya() {
    this.bsModalRef.hide();
    this.dialog.open(SimplePaymentModalComponent, {
      data: {
        bookingId: null,
        amount: null,
      },
    });
  }

}
